import { useEffect, useState } from "react";
import dayjs from "dayjs";

export const INITIAL_CONTACT_MODAL_STATE = {
  firstName: "",
  surname: "",
  email: "",
  phone: "",
  kyc: {
    dob: null,
    employmentStatus: "",
    annualIncome: "",
    targetRetirementAge: "",
    idDocType: "",
  },
  admin: {
    title: "",
    jobTitle: "",
  },
};

/**
 * Owns the contact + relationship form state and resets it every time the
 * modal opens (either to the passed-in contactData/relationshipData, or to
 * blank defaults for a new contact).
 */
export function useContactForm(contactData: any, relationshipData: any, open: boolean) {
  const [formData, setFormData] = useState(INITIAL_CONTACT_MODAL_STATE);
  const [relationshipForm, setRelationshipForm] = useState({
    relationshipType: "",
    isPrimary: false,
  });
  const [showAdditionalDetails, setShowAdditionalDetails] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!open) return;

    if (contactData) {
      const nameParts = (contactData.name || "").split(" ");
      const firstName = nameParts[0] || "";
      const surname = nameParts.slice(1).join(" ") || "";
      const rawTitle = contactData.admin?.title || "";
      const normalizedTitle = rawTitle.replace(/\./g, "");

      setFormData({
        firstName,
        surname,
        email: contactData.email || "",
        phone: contactData.phone || "",
        kyc: {
          dob: contactData.kyc?.dob ? dayjs(contactData.kyc.dob) : null,
          employmentStatus: contactData.kyc?.employmentStatus || "",
          annualIncome: contactData.kyc?.annualIncome || "",
          targetRetirementAge: contactData.kyc?.targetRetirementAge || "",
          idDocType: contactData.kyc?.idDocType || "",
        },
        admin: {
          title: normalizedTitle,
          jobTitle: contactData.admin?.jobTitle || "",
        },
      });
      setShowAdditionalDetails(false);
    } else {
      setFormData(INITIAL_CONTACT_MODAL_STATE);
      setShowAdditionalDetails(false);
    }

    if (relationshipData) {
      setRelationshipForm({
        relationshipType: relationshipData.relationshipType || "",
        isPrimary: relationshipData.isPrimary || false,
      });
    } else {
      setRelationshipForm({ relationshipType: "", isPrimary: false });
    }
  }, [contactData, relationshipData, open]);

  const handleChange = (section: string | null, field: string, value: any) => {
    if (section) {
      setFormData((prev: any) => ({
        ...prev,
        [section]: { ...prev[section], [field]: value },
      }));
    } else {
      setFormData((prev) => ({ ...prev, [field]: value }));
    }
  };

  return {
    formData,
    relationshipForm,
    setRelationshipForm,
    handleChange,
    showAdditionalDetails,
    setShowAdditionalDetails,
  };
}
